export default {
  main: '#000000',
  secondary: '#EBC15B',
  contrastingColor: '#ffffff',
  priceColor: '#EBC15B',
  entryBackground: '#f8f8f8',
  menuBackgroundColor: '#ffffff',
  menuTextColor: '#000000',
};
